import { useSelector } from "react-redux";

export default function VideoChatProgressComponent() {
  const user = useSelector((state) => state.profile.user);

  return (
    <div>
      <div className="flex justify-between items-center mb-1">
        <span className="text-base text-pink-300/70">Video Chat Time:</span>
        <span className="text-base text-white">
          {user
            ? `${Math.floor(user.maxVideoCallTime) - Math.floor(user.currentVideoCallUsage ?? 0)}/${Math.floor(user.maxVideoCallTime)} minutes left`
            : "0/0 minutes left"}
        </span>
      </div>
      <div className="w-full bg-slate-800 rounded-full h-2.5">
        <div
          className="bg-gradient-to-r from-red-800 to-red-900 h-2.5 rounded-full"
          style={{
            width:
              user && user.maxVideoCallTime > 0
                ? `${Math.min(100, ((user.maxVideoCallTime - user.currentVideoCallUsage) / user.maxVideoCallTime) * 100)}%`
                : "0%",
          }}
        ></div>
      </div>
    </div>
  );
}
